import debounce from "lodash/debounce";
import React, { useCallback, useEffect, useState } from "react";
import TasksInner from "./tasks.inner";
export default function Tasks({ filterText, ...other }) {
    const [filterTextDebounced, setFilterTextDebounced] = useState(filterText);
    const filterChangedCallback = useCallback(debounce((text) => {
        setFilterTextDebounced(text);
    }, 400), []);
    useEffect(() => {
        filterChangedCallback(filterText);
    }, [filterText]);
    return React.createElement(TasksInner, { filterText: filterTextDebounced, ...other });
}
